import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-6"
      style={{ background: "var(--canvas)" }}
    >
      <div className="w-full max-w-md text-center">
        <div
          style={{
            fontFamily: "'JetBrains Mono', ui-monospace, monospace",
            fontSize: 10.5,
            fontWeight: 500,
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: "var(--ink-faint)",
            marginBottom: 14,
          }}
        >
          404 <span style={{ color: "var(--accent)" }}>·</span> Lost
        </div>
        <h1
          style={{
            fontFamily: "'Source Serif 4', Georgia, serif",
            fontWeight: 500,
            fontSize: 36,
            letterSpacing: "-0.02em",
            color: "var(--ink)",
          }}
        >
          That page <em style={{ color: "var(--accent-ink)", fontStyle: "italic" }}>doesn't exist</em>.
        </h1>
        <p
          style={{
            marginTop: 12,
            fontSize: 15,
            lineHeight: 1.55,
            color: "var(--ink-soft)",
            maxWidth: "40ch",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          Either the link is wrong, or the business you're looking for has been removed. Head back to your dashboard and start over.
        </p>
        <div
          style={{
            marginTop: 28,
            display: "flex",
            gap: 10,
            justifyContent: "center",
          }}
        >
          <button onClick={() => navigate("/")} className="zd-hero-cta">
            Go to dashboard
          </button>
          <button onClick={() => navigate(-1)} className="zd-ghost-btn" style={{ height: 44, padding: "0 16px", fontSize: 13.5 }}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
}
